// cSpell:ignore flexbox, STYuanti, vertical

import React from 'react';
import styled, { keyframes } from 'styled-components';
import PropTypes from 'prop-types';

import ProgressBar from '../../lib/components/LessonPath/lesson-progress-bar';
import RowStar from '../../lib/components/LessonPath/lesson-row-star';
import { Flex, LessonNumber, LessonTag, EllipsisTwoCell } from '../../lib/components/LessonPath/static/style';
import { COURSE_TYPE } from '../../lib/components/LessonPath/static/json/constant';

export default class LessonCard extends React.Component {
    // 用来存储当前选中鼠标滑过的那一个
    mouseOverHandler(cid) {
        const { onMouseOver } = this.props;

        if (cid && onMouseOver && typeof onMouseOver === 'function') {
            onMouseOver(cid);
        }
    }

    render() {
        const { data, activeCid } = this.props;

        return (
            <CardBox
                id={`card_${data.nodeDetails && data.nodeDetails.lessonCid ? data.nodeDetails.lessonCid : ''}`}
                onClick={() => this.context.clickCardHandler(data)}
            >
                <Card
                    onMouseOver={() => this.mouseOverHandler(data.nodeDetails && data.nodeDetails.lessonCid ? data.nodeDetails.lessonCid : '')}
                    className={data.nodeDetails && data.nodeDetails.lessonCid
                        ? (data.currentCid && data.nodeDetails.lessonCid === data.currentCid ? 'current'
                            : (activeCid && data.nodeDetails.lessonCid === activeCid ? 'active' : ''))
                        : ''}
                >
                    {data && data.nodeDetails && data.nodeDetails.lessonTag &&
                        <LessonTag
                            type={data && data.index ? this.props.data.index + 1 : 1}
                            long={data.nodeType && data.nodeType === COURSE_TYPE.ctLesson ? true : false}
                        >
                            {data.nodeDetails.lessonTag}
                        </LessonTag>
                    }
                    <LessonPicture src={data && data.nodeImageURL ? data.nodeImageURL : ''} nodeType={data.nodeType} />
                    <LessonTitle>
                        <EllipsisTwoCell>{data && data.nodeDetails && data.nodeDetails.lessonName ? data.nodeDetails.lessonName : ''}</EllipsisTwoCell>
                    </LessonTitle>
                    {/* 老版有进度 */}
                    {/* {data.nodeDetails && data.nodeDetails.lessonStars && data.nodeDetails.lessonStars >= 0
                        ? <RowStar maxLength={5} star={data.nodeDetails.lessonStars} />
                        : data.nodeDetails && data.nodeDetails.lessonType && data.nodeDetails.lessonType === 'campLesson'
                            && data.nodeDetails.lessonCourseId && data.nodeDetails.lessonCourseId.unit
                            && parseInt(data.nodeDetails.lessonCourseId.unit, 10) === 22
                            ? <RowStar maxLength={5} star={0} />
                            // 如果是 web 类型的卡片，就直接显示文案
                            // : <ProgressBar data={getProgressData(data)} />
                            : (data.nodeType && data.nodeType === COURSE_TYPE.web
                                ? <WebText>{data.nodeTitle}</WebText>
                                : <ProgressBar data={getProgressData(data)} />
                            )
                    } */}
                    {/* 新版无进度 只显示星星 */}
                    {data.nodeType && data.nodeType === COURSE_TYPE.web
                        ? <WebText>Level {data.level || 'K'} <br />{data.nodeTitle}</WebText>
                        : <RowStar maxLength={5} star={data.nodeDetails && data.nodeDetails.lessonStars ? data.nodeDetails.lessonStars : 0} />}
                </Card>
                <LessonNum type={data && data.nodeType && data.nodeType === COURSE_TYPE.trialLesson ? 'star' : null} nodeType={data.nodeType}>
                    {data.nodeTitle && parseInt(data.nodeTitle, 10) ? parseInt(data.nodeTitle, 10) : ''}
                    {data.nodeType === COURSE_TYPE.web ? "✎" : ''}
                </LessonNum>
            </CardBox>
        );
    }
}

LessonCard.contextTypes = {
    clickCardHandler: PropTypes.func
}

const getProgressData = (data) => {
    if (!data) {
        return [];
    }

    const barData = [];
    if (data.nodeType && data.nodeType === COURSE_TYPE.ctLesson) {
        barData.push({
            text: '单元总结',
            status: data.nodeDetails ? data.nodeDetails.lessonSummaryStatus : false
        }, {
            text: '学习',
            status: data.nodeDetails ? data.nodeDetails.lessonStatus : false
        });
    } else if (data.nodeType && data.nodeType === COURSE_TYPE.expandLesson) {
        barData.push({
            text: '学习',
            status: data.nodeDetails ? data.nodeDetails.lessonStatus : false
        }, {
            text: '练一练',
            status: data.nodeDetails ? data.nodeDetails.lessonHomeworkStatus : false
        });
    } else {
        barData.push({
            text: '预习',
            status: data.nodeDetails ? data.nodeDetails.lessonPreviewStatus : false
        }, {
            text: '学习',
            status: data.nodeDetails ? data.nodeDetails.lessonStatus : false
        }, {
            text: '练一练',
            status: data.nodeDetails ? data.nodeDetails.lessonHomeworkStatus : false
        });
    }

    return barData;
}

const CardFloat = keyframes`
    0: {
        margin-top: 0;
    }
    50% {
        margin-top: -0.4rem;
    }

    100% {
        margin-top: 0rem;
    }
`;

const CardBig = keyframes`
    0% {
        margin-top: 0;
    }
    100% {
        margin-top: -0.4rem;
        transform: scale(1.1);
        -webkit-transform: scale(1.1);
    }
`;

const CardBox = styled.div`
    position: relative;
    width: 3.2rem;
    /* height: 6rem; */
    /* height: 6.64rem; */
    height: 6.3rem;
    margin: 3.08rem 0.6rem 0.6rem 0.6rem;
    cursor: pointer;
`;

const Card = styled(Flex)`
    position: relative;
    width: 3.2rem;
    /* height: 3.71rem; */
    /* height: 4.35rem; */
    height: 4rem;
    border-radius: 0.26rem;
    background: #fff;
    padding: 0.26rem 0.3rem 0.16rem 0.3rem;
    flex-direction: column;
    transition: all 0.1s linear;

    &::after {
        position: absolute;
        display: block;
        content: '';
        bottom: -0.1rem;
        left: 50%;
        transform: translateX(-50%) rotateZ(45deg);
        -webkit-transform: translateX(-50%) rotateZ(45deg);
        width: 0.6rem;
        height: 0.6rem;
        background: #fff;
        border-radius: 0.15rem;
    }

    &.active {
        box-shadow: 0px 0px 38px 0px rgba(96, 200, 49, 1);
        /* animation: 3s ${CardFloat} infinite; */
        margin-top: -0.4rem;
        transform: scale(1.1);
        -webkit-transform: scale(1.1);
        transition: all 0.4s linear;
    }

    &.current {
        padding: 0.2rem 0.2rem 0.1rem 0.2rem;
        margin-top: -0.4rem;
        box-shadow: 0 0 0.4rem rgba(239, 134, 67, 1);
        transform: scale(1.1);
        -webkit-transform: scale(1.1);
        border: 0.1rem solid #ef8643 !important;

        &::after {
            /* bottom: -0.24rem; */
            bottom: -0.251rem;
            transform: translateX(-50%) rotateZ(0);
            -webkit-transform: translateX(-50%) rotateZ(0);
            background: url(${require('./img/little-trg-current-copy.png')}) no-repeat center bottom;
            background-size: contain;
        }
    }
`;

const LessonNum = styled(LessonNumber)`
    position: absolute;
    bottom: 0.7rem;
    left: 50%;
    transform: translateX(-50%);

    ${props => props.nodeType && props.nodeType === COURSE_TYPE.web ? `
        transform: translateX(-50%) rotateY(180deg);
    ` : ``}
`;

const LessonPicture = styled.div`
    flex: none;
    /* width: 100%;
    height: 1.63rem; 
    border-radius: 0.16rem; */
    margin: 0 auto;
    height: 2.24rem;
    width: 2.24rem;
    background: url(${props => props.src ? props.src : ''}) no-repeat center;
    background-size: cover;

    ${props => props.nodeType && props.nodeType === COURSE_TYPE.web ? `
        background-size: contain;
    ` : `
        border-radius: 50%;
    `}
`;

const LessonTitle = styled(Flex)`
    justify-content: center;
    align-items: center;
    font-family: STYuanti-SC-Regular,STYuanti-SC;
    font-weight: 400;
    height: 0.8rem;
    font-size: 0.26rem;
    text-align: center;
    margin: 0.1rem 0.24rem auto;
`;

const WebText = styled.div`
    position: relative;
    color: #646464;
    font-size: 0.22rem;
    text-align: center;
    height: 1rem;
    z-index: 1;
    line-height: 0.5rem;
`;


// WEBPACK FOOTER //
// ./src/components/lesson-path/lesson-card.js